import React from 'react';
import styled from 'styled-components';
import { DateParam } from './DateParam';
import { SelectParam } from './SelectParam';
import { HeaderButtons } from './HeaderButtons';
import { ReportDescription } from './ReportDescription';
const ReportParamHeaderContainer = styled.div.withConfig({
  displayName: "ReportParamHeader__ReportParamHeaderContainer",
  componentId: "bxgg9n-0"
})(["display:flex;flex-wrap:wrap;min-height:4.14em;"]);
const ParamContainer = styled.div.withConfig({
  displayName: "ReportParamHeader__ParamContainer",
  componentId: "bxgg9n-1"
})(["padding:5px;"]);
export const ReportParamHeader = ({
  reportHeader
}) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ReportDescription, {
  reportHeader: reportHeader
}), /*#__PURE__*/React.createElement(ReportParamHeaderContainer, null, reportHeader && reportHeader.reportParams.map(param => /*#__PURE__*/React.createElement(ParamContainer, null, /*#__PURE__*/React.createElement("div", null, param.name, ":"), renderParam(param))), /*#__PURE__*/React.createElement(HeaderButtons, {
  reportHeader: reportHeader
})));

var _ref = /*#__PURE__*/React.createElement("div", null);

const renderParam = param => {
  switch (param.type) {
    case 'date':
      return /*#__PURE__*/React.createElement(DateParam, {
        param: param
      });

    case 'select':
      return /*#__PURE__*/React.createElement(SelectParam, {
        param: param
      });

    default:
      return _ref;
  }
};